/* eslint-disable no-undef */
import { useEffect } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Style/Style.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import AppRoutes from "./routes/AppRoutes";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Toaster } from "react-hot-toast";
// import {
//   useStripe,
// } from "@stripe/react-stripe-js";

function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#00bf6f",
      },
    },
    typography: {
      fontFamily: `"Inter", "Inter-Fallback", Arial, system-ui, sans-serif, "Segoe UI", Roboto, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    },
  });

  useEffect(() => {
    AOS.init({
      // disable: function () {
      // constmaxWidth = 567;
      // return window.innerWidth < maxWidth;
      // },
      duration: 2000,
    });

    const chatTag = localStorage.getItem("toolTip");

    if (!chatTag) {
      localStorage.setItem("toolTip", "open");
    }
  }, []);

  return (
    <div id="app_r" className={`App overflow-x-hidden`}>
      <ThemeProvider theme={theme}>
        <AppRoutes />
      </ThemeProvider>
      <Toaster />
    </div>
  );
}

export default App;
